import axios from 'axios';
import { SUPPORT_BASE_API_URL } from '../config/config';

export const api = axios.create({
    baseURL: SUPPORT_BASE_API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// ✅ Sirf Authorization rakho
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});


